import React, { useState, useCallback, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { toast } from "react-toastify";

import { Label, Button, Popup, Grid, Header, Icon, Segment, Transition } from "semantic-ui-react";
import TemplateTable from "../../components/TemplateTable";
import { ITableAppRender } from "../../components/TableApp";

import KitRepository, { IKitListModel } from "../../Repositories/KitRepository";
import api from "../../services/api";
import { ISearch } from "../../components/Search";

import errors from "../../Utils/ExtractErrors";
import { eStatusKit, ISearchResponse } from "../../interfaces";
import { GetUser } from "../../services/auth";
import EditarKit from "./EditarKit";
import { IFields } from "../../components/Search/FilterBuilder";
import numberFormat from "../../Utils/NumberFormat";
import { CSVLink } from "react-csv";

const Kits: React.FC = () => {

    const [list, setList] = useState<IKitListModel[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [predefined, setPredefined] = useState<boolean>(false);
    const [visible, setVisible] = useState<boolean>(false);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    const date = new Date();
    const actualYear = date.getFullYear();
    const actualMonth = date.getMonth() + 1;

    const { role } = GetUser();

    const onChangeRecords = (value: number) => {
        refRecordsByPage.current = value;
        load();
    }

    const onClickPredefined = () => {
        setPredefined(!predefined);
        setVisible(!visible);
    }

    const onPageChange = (pageNumber: string | number | undefined) => {
        refPageNumber.current = pageNumber;
        load();
    }

    const setWarning = (prorrogado: number, numero: number, tipo: number) => {
        if (prorrogado === 1 && tipo === 0) {
            return <Popup trigger={<Label icon="warning sign" color="orange" size="large" content={numero} />} hoverable content="Kit Novo"></Popup>
        }
        else if (prorrogado === 1 && tipo === 1) {
            return <Popup trigger={<Label icon="warning sign" color="orange" size="large" content={numero} />} hoverable content="Kit Acerto"></Popup>
        }
        else if (prorrogado === 0 && tipo === 0) {
            return <Label color="pink" size="large" content={numero} />
        }
        else if (prorrogado === 0 && tipo === 1) {
            return <Label color="purple" size="large" content={numero} />
        }
        else {
            return numero;
        }
    }

    const setEstado = (estado: number, gerenteSetor: string, valorVendido: number, valorRecebido: number, valorDebito: number, valor: number,
        valorVendidoEmp: number, valorDif: number, dataPreConferencia: string, valorCorrigido: number) => {
        switch (estado) {
            case 1:
                return <Popup trigger={<Label ribbon icon="user times" color="red" content="DEV" />} large wide hoverable>
                    {
                        (role !== "Admin" && role !== "Operador") &&
                        <Grid centered divided columns={1}>
                            <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                            <Grid.Column textAlign='center'>
                                <Header as='h4'>Conf. Rep.</Header>
                                <b>
                                    <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                    {
                                        valorCorrigido > 0 ?
                                            <>
                                                <p>{`Valor Atualizado: ${numberFormat.Currency(valorCorrigido)}`}</p>
                                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                                <p>{`Valor Débito: ${numberFormat.Currency(valorCorrigido - valorRecebido)}`}</p>
                                            </>
                                            :
                                            <>
                                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                                <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}</p>
                                            </>
                                    }
                                </b>
                            </Grid.Column>
                        </Grid>
                    }
                    {
                        (role === "Admin" || role === "Operador") &&
                        <Grid centered divided columns={2}>
                            <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                            <Grid.Column textAlign='center'>
                                <Header as='h4'>Conf. Rep.</Header>
                                <b>
                                    <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                    {
                                        valorCorrigido > 0 ?
                                            <>
                                                <p>{`Valor Atualizado: ${numberFormat.Currency(valorCorrigido)}`}</p>
                                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                                <p>{`Valor Débito: ${numberFormat.Currency(valorCorrigido - valorRecebido)}`}</p>
                                            </>
                                            :
                                            <>
                                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                                <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}</p>
                                            </>
                                    }
                                </b>
                            </Grid.Column>
                            <Grid.Column textAlign='center'>
                                <Header as='h4'>Conf. Emp.</Header>
                                <b>
                                    <p>{`Venda Bruta: ${numberFormat.Currency(valorVendidoEmp)}`}</p>
                                    {
                                        valorDif > 0 ?
                                            <p>
                                                <Label color="green">
                                                    <Icon name='plus circle' />
                                                    {numberFormat.Currency(valorDif)}
                                                </Label>
                                            </p>
                                            :
                                            <p>
                                                <Label color="red">
                                                    <Icon name='minus circle' />
                                                    {numberFormat.Currency(valorDif)}
                                                </Label>
                                            </p>
                                    }
                                </b>
                            </Grid.Column>
                            <small>{`Pré-Conferencia: ${format(new Date(dataPreConferencia), "dd/MM/yyyy HH:mm:ss")}`}</small>
                        </Grid>
                    }
                </Popup>
            case 2:
                return <Popup trigger={<Label ribbon icon="thumbs down" color="black" content="NRT" />} wide hoverable>
                    <Grid>
                        <Grid.Column textAlign='left'>
                            <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                            <b>
                                <p>{`Valor Débito: ${numberFormat.Currency(valor)}`}</p>
                            </b>
                        </Grid.Column>
                    </Grid>
                </Popup>
        }
    }

    const setLiberacao = (liberacao: number) => {
        switch (liberacao) {
            case 0:
                return ""
            case 1:
                return <Label color="brown" align="center" content="Aguardando liberação" />
            case 2:
                return <Label color="green" align="center" content="Liberado" />
            case 3:
                return <Label color="black" align="center" content="Não Liberado" />
        }
    }
    const setStatus = (status: number, gerenteSetor: string, valorVendido: number, dataEntrega: string, valorRecebido: number,
        valorDebito: number, valorVendidoEmp: number, valorDif: number, dataPreConferencia: string) => {
        switch (status) {
            case 0:
                return <Label ribbon icon="box" content="EST" />
            case 1:
                return <Popup
                    trigger={<Label ribbon icon="user" color="pink" content="GES" />}
                    content={`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}
                    wide
                />
            case 2:
                return <Popup
                    trigger={<Label ribbon icon="id badge" color="violet" content="REP" />}
                    content={`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}
                    wide
                />
            case 3:
                return <Popup
                    trigger={<Label ribbon icon="street view" color="teal" content="REV" />}
                    header={`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}
                    content={`Data de Entrega: ${format(new Date(dataEntrega), "dd/MM/yyyy HH:mm:ss")}`}
                    wide
                />
            case 4:
                return <Popup trigger={<Label ribbon icon="stopwatch" color="blue" content="PRÉ" />} large wide hoverable>

                    <Grid centered divided columns={1}>
                        <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                        <Grid.Column textAlign='center'>
                            <b>
                                <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}<br />
                                    {(role == "Admin" || role == "Operador") &&
                                        <small>{`Pré-Conferencia: ${format(new Date(dataPreConferencia), "dd/MM/yyyy HH:mm:ss")}`}</small>
                                    }
                                </p>
                            </b>
                        </Grid.Column>
                    </Grid>
                </Popup>
            case 5:
                return <Popup trigger={<Label ribbon icon="thumbs down outline" color="orange" content="CFE" />} large wide hoverable>
                    {
                        (role === "Admin" || role === "Operador") &&
                        <Grid centered divided columns={2}>
                            <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                            <Grid.Column textAlign='center'>
                                <Header as='h4'>Conf. Rep.</Header>
                                <b>
                                    <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                    <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                    <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}</p>
                                </b>
                            </Grid.Column>
                            <Grid.Column textAlign='center'>
                                <Header as='h4'>Conf. Emp.</Header>
                                <b>
                                    <p>{`Venda Bruta: ${numberFormat.Currency(valorVendidoEmp)}`}</p>
                                    <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                    {
                                        valorDif > 0 ?
                                            <p>
                                                <Label color="green">
                                                    <Icon name='plus circle' />
                                                    {numberFormat.Currency(valorDif)}
                                                </Label>
                                            </p>
                                            :
                                            <p>
                                                <Label color="red">
                                                    <Icon name='minus circle' />
                                                    {numberFormat.Currency(valorDif)}
                                                </Label>
                                            </p>
                                    }
                                </b>
                            </Grid.Column>
                            <b><small>{`Pré-Conferencia: ${format(new Date(dataPreConferencia), "dd/MM/yyyy HH:mm:ss")}`}</small></b>
                        </Grid>
                    }
                </Popup>
            case 6:
                return <Popup trigger={<Label ribbon icon="thumbs up outline" color="purple" content="CGS" />} large wide hoverable>

                    <Grid centered divided columns={1}>
                        <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                        <Grid.Column textAlign='center'>
                            <b>
                                <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}<br />
                                    {(role == "Admin" || role == "Operador") &&
                                        <small>{`Pré-Conferencia: ${format(new Date(dataPreConferencia), "dd/MM/yyyy HH:mm:ss")}`}</small>
                                    }
                                </p>
                            </b>
                        </Grid.Column>
                    </Grid>
                </Popup>
            case 7:
                return <Popup trigger={<Label ribbon icon="handshake" color="olive" content="CGR" />} large wide hoverable>

                    <Grid centered divided columns={1}>
                        <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                        <Grid.Column textAlign='center'>
                            <b>
                                <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}<br />
                                    {(role == "Admin" || role == "Operador") &&
                                        <small>{`Pré-Conferencia: ${format(new Date(dataPreConferencia), "dd/MM/yyyy HH:mm:ss")}`}</small>
                                    }
                                </p>
                            </b>
                        </Grid.Column>
                    </Grid>
                </Popup>
            case 8:
                return <Popup trigger={<Label ribbon icon="check" color="green" content="FIN" />} large wide hoverable>

                    <Grid centered divided columns={1}>
                        <Header as='h4'>{`G. Setor: ${gerenteSetor !== null ? gerenteSetor : "Indefinido"}`}</Header>
                        <Grid.Column textAlign='center'>
                            <b>
                                <p>{`Venda Bruta: ${numberFormat.Currency(valorVendido)}`}</p>
                                <p>{`Valor Recebido: ${numberFormat.Currency(valorRecebido)}`}</p>
                                <p>{`Valor Débito: ${numberFormat.Currency(valorDebito)}`}<br />
                                    {(role == "Admin" || role == "Operador") &&
                                        <small>{`Pré-Conferencia: ${format(new Date(dataPreConferencia), "dd/MM/yyyy HH:mm:ss")}`}</small>
                                    }
                                </p>
                            </b>
                        </Grid.Column>
                    </Grid>
                </Popup>
            default:
                return <Label ribbon icon="dont" color="grey" content="???" />
        }
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Status",
            content: (x: IKitListModel) => x.estado !== 0 ? setEstado(x.estado, x.gerenteSetor, x.valorVendido, x.valorRecebido, x.valorDebito, x.valor, x.valorVendidoEmp, x.valorDif, x.dataPreConferencia, x.valorCorrigido) : setStatus(x.status, x.gerenteSetor, x.valorVendido, x.dataEntrega, x.valorRecebido, x.valorDebito, x.valorVendidoEmp, x.valorDif, x.dataPreConferencia),
            textAlign: "left",
            width: 1
        },
        {
            header: "Liberação",
            content: (x: IKitListModel) => setLiberacao(x.liberacao),
            textAlign: "left",
            width: 1
        },
        {
            header: "Número",
            content: (x: IKitListModel) => setWarning(x.prorrogado, x.numero, x.tipo),
            textAlign: "center",
            width: 2
        },
        {
            header: "Representante",
            content: (x: IKitListModel) => x.representante,
            width: 4
        },
        {
            header: "Revendedor",
            content: (x: IKitListModel) => x.revendedor,
            width: 4
        },
        {
            header: "Acerto",
            content: (x: IKitListModel) => x.acerto !== null ? format(new Date(x.acerto), "dd/MM/yyyy") : "",
            textAlign: "center",
            width: 1
        },
    ];


    const handlePrint = (id: string) => {
        var a = document.createElement("a");
        a.href = `${api.defaults.baseURL}/kit/${id}/print`;
        a.setAttribute("target", "_blank");
        a.click();
    }

    const printButton = (id: string) => (
        <Button
            key={`kits_print_${id}`}
            icon="print"
            color="blue"
            onClick={() => handlePrint(id)}
        />
    );

    const manageButton = ({ id, gerenteSetor, representante, revendedor, acerto }: { id: string; gerenteSetor: string; representante: string; revendedor: string; acerto: string; }) => (
        <Button
            key={`kits_manage_${id}`}
            as={Link}
            icon="terminal"
            color="orange"
            to={{
                pathname: `/managekit/${id}`,
                state: {
                    gerenteSetor,
                    representante,
                    revendedor,
                    acerto
                }
            }}
        />
    );

    const load = useCallback(async () => {

        setLoading(true);
        try {
            let response: ISearchResponse<IKitListModel>;

            if (refSearch.current.type === "simples") {
                response = await KitRepository.List({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            } else {
                response = await KitRepository.List({
                    filter: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setList(response.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }, []);

    const onSearch = ({ searchString, type }: ISearch) => {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;
        setPredefined(false);
        setVisible(false);
        load();
    }

    useEffect(() => { load() }, [load]);

    const fields: IFields[] = [
        { label: "G. Regional", name: "Pedido.GerenteRegional.Nome", type: "string", roles: ["Admin", "Operador"] },
        { label: "G. Setor", name: "Pedido.GerenteSetor.Nome", type: "string", roles: ["Admin", "Operador", "GerenteR"] },
        { label: "Representante", name: "Pedido.Representante.Nome", type: "string", roles: ["Admin", "Operador", "GerenteR", "GerenteS"] },
        { label: "Revendedor", name: "Revendedor.Nome", type: "string", roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"] },
        { label: "Acerto", name: "Pedido.Acerto", type: "date", roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"] },
        { label: "Data Entrega", name: "DataEntrega", type: "date", roles: ["Admin", "Operador", "GerenteR", "GerenteS"] },
        {
            label: "Liberação",
            name: "liberacao",
            type: "enum",
            values: [
                { key: "NOR", text: "NOR", value: 0, label: { color: "grey", content: "Normal" } },
                { key: "PEN", text: "PEN", value: 1, label: { color: "brown", content: "Pendente" } },
                { key: "LIB", text: "LIB", value: 2, label: { color: "green", content: "Liberado" } }
            ],
            roles: ["Admin", "Operador"]
        },
        {
            label: "Status",
            name: "StatusKit",
            type: "enum",
            values: [
                { key: "EST", text: "EST", value: 0, label: { icon: "box", content: "EST" } },
                { key: "GES", text: "GES", value: 1, label: { icon: "user", color: "pink", content: "GES" } },
                { key: "REP", text: "REP", value: 2, label: { icon: "id badge", color: "violet", content: "REP" } },
                { key: "REV", text: "REV", value: 3, label: { icon: "street view", color: "teal", content: "REV" } },
                { key: "PRE", text: "PRE", value: 4, label: { icon: "stopwatch", color: "blue", content: "PRE" } },
                { key: "CFE", text: "CFE", value: 5, label: { icon: "thumbs down outline", color: "orange", content: "CFE" } },
                { key: "CGS", text: "CGS", value: 6, label: { icon: "thumbs up outline", color: "purple", content: "CGS" } },
                { key: "CGR", text: "CGR", value: 7, label: { icon: "handshake", color: "olive", content: "CGR" } },
                { key: "FIN", text: "FIN", value: 8, label: { icon: "check", color: "green", content: "FIN" } },
            ],
            roles: ["Admin", "Operador"]
        },
        {
            label: "Status",
            name: "StatusKit",
            type: "enum",
            values: [
                { key: "GES", text: "GES", value: 1, label: { icon: "user", color: "pink", content: "GES" } },
                { key: "REP", text: "REP", value: 2, label: { icon: "id badge", color: "violet", content: "REP" } },
                { key: "REV", text: "REV", value: 3, label: { icon: "street view", color: "teal", content: "REV" } },
                { key: "PRE", text: "PRE", value: 4, label: { icon: "stopwatch", color: "blue", content: "PRE" } },
                { key: "CFE", text: "CFE", value: 5, label: { icon: "thumbs down outline", color: "orange", content: "CFE" } },
                { key: "CGS", text: "CGS", value: 6, label: { icon: "thumbs up outline", color: "purple", content: "CGS" } },
                { key: "CGR", text: "CGR", value: 7, label: { icon: "handshake", color: "olive", content: "CGR" } },
                { key: "FIN", text: "FIN", value: 8, label: { icon: "check", color: "green", content: "FIN" } },
            ],
            roles: ["GerenteR"]
        },
        {
            label: "Status",
            name: "StatusKit",
            type: "enum",
            values: [
                { key: "REP", text: "REP", value: 2, label: { icon: "id badge", color: "violet", content: "REP" } },
                { key: "REV", text: "REV", value: 3, label: { icon: "street view", color: "teal", content: "REV" } },
                { key: "PRE", text: "PRE", value: 4, label: { icon: "stopwatch", color: "blue", content: "PRE" } },
                { key: "CFE", text: "CFE", value: 5, label: { icon: "thumbs down outline", color: "orange", content: "CFE" } },
                { key: "CGS", text: "CGS", value: 6, label: { icon: "thumbs up outline", color: "purple", content: "CGS" } },
                { key: "CGR", text: "CGR", value: 7, label: { icon: "handshake", color: "olive", content: "CGR" } },
                { key: "FIN", text: "FIN", value: 8, label: { icon: "check", color: "green", content: "FIN" } },
            ],
            roles: ["GerenteS"]
        },
        {
            label: "Status",
            name: "StatusKit",
            type: "enum",
            values: [
                { key: "REV", text: "REV", value: 3, label: { icon: "street view", color: "teal", content: "REV" } },
                { key: "PRE", text: "PRE", value: 4, label: { icon: "stopwatch", color: "blue", content: "PRE" } },
                { key: "CFE", text: "CFE", value: 5, label: { icon: "thumbs down outline", color: "orange", content: "CFE" } },
                { key: "CGS", text: "CGS", value: 6, label: { icon: "thumbs up outline", color: "purple", content: "CGS" } },
                { key: "CGR", text: "CGR", value: 7, label: { icon: "handshake", color: "olive", content: "CGR" } },
                { key: "FIN", text: "FIN", value: 8, label: { icon: "check", color: "green", content: "FIN" } },
            ],
            roles: ["Representante"]
        },
        {
            label: "Tipo",
            name: "Tipo",
            type: "enum",
            values: [
                { key: "PRI", text: "PRI", value: 0, label: { icon: "hand point up outline", color: "pink", content: "PRI" } },
                { key: "ACT", text: "ACT", value: 1, label: { icon: "hand peace outline", color: "purple", content: "ACT" } }
            ],
            roles: ["Admin", "Operador", "GerenteR", "GerenteS"]
        },
        {
            label: "Prorrogado",
            name: "Prorrogado",
            type: "enum",
            values: [
                { key: "SIM", text: "SIM", value: 1, label: { icon: "check", color: "green", content: "SIM" } },
                { key: "NAO", text: "NAO", value: 0, label: { icon: "times", color: "red", content: "NAO" } }
            ],
            roles: ["Admin", "Operador", "GerenteR", "GerenteS"]
        },
        { label: "Número", name: "Numero", type: "number", roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"] },
    ];

    const headers = [
        "ID", "STATUS", "NÚMERO", "G. SETOR", "REPRESENTANTE", "REVENDEDOR", "DATA ACERTO", "R$ VALOR KIT", "PRORROGADO",
        "ESTADO", "R$ VENDA REP.", "DATA ENTREGA", "R$ PAGO", "R$ DÉBITO", "R$ VENDA EMP.", "R$ DIF", "LIBERAÇÃO", "TIPO", "", "", "", "DATA PRÉ"
    ]
    const csvReport = {
        data: list.map(row => Object.values(row)),
        headers: headers,
        filename: 'Kits.csv'
    };

    const predefinedRegion = (
        <Grid>
            <Grid.Column>
                <Segment color="pink">
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Popup hoverable content='Kits que estão aguardando verificação das fotos.' position="bottom center" trigger={
                                    <Button
                                        icon="clock"
                                        fluid
                                        color="grey"
                                        content="Aguardando"
                                        onClick={() => onSearch({ searchString: "STATUSKIT == 2 && LIBERACAO == 1", type: "avancado" })}
                                    />
                                }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Popup hoverable content='Kits que tem divergência para liberação.' position="bottom center" trigger={
                                    <Button
                                        icon="dont"
                                        fluid
                                        color="grey"
                                        content="Não Liberados"
                                        onClick={() => onSearch({ searchString: "STATUSKIT == 2 && LIBERACAO == 3", type: "avancado" })}
                                    />
                                }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Popup hoverable content='Kits que estão no estoque (novo e acerto).' position="bottom center" trigger={
                                    <Button
                                        icon="boxes"
                                        fluid
                                        color="grey"
                                        content="Estoque"
                                        onClick={() => onSearch({ searchString: "STATUSKIT == 0", type: "avancado" })}
                                    />
                                }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Popup hoverable content='Kits que foram pré-conferidos no mês atual.' position="bottom center" trigger={
                                    <Button
                                        icon="stopwatch"
                                        fluid
                                        color="grey"
                                        content="Conferidos"
                                        onClick={() => onSearch({
                                            searchString: `CONFERENCES.ANY(CONFERENCE => CONFERENCE.CONFERENCETYPE = 0 AND CONFERENCE.DATA >= "${actualYear}-${actualMonth}-01" AND CONFERENCE.DATA < "${actualYear}-${actualMonth + 1}-01")`,
                                            type: "avancado"
                                        })}
                                    />
                                }
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Popup hoverable content='Kits que foram pré-conferidos no mês atual (Com vendas).' position="bottom center" trigger={
                                    <Button
                                        icon="money"
                                        fluid
                                        color="grey"
                                        content="Conferidos C/V"
                                        onClick={() => onSearch({
                                            searchString: `CONFERENCES.ANY(CONFERENCE => CONFERENCE.CONFERENCETYPE = 0 AND CONFERENCE.VALORVENDIDO > 0 AND CONFERENCE.DATA >= "${actualYear}-${actualMonth}-01" AND CONFERENCE.DATA < "${actualYear}-${actualMonth + 1}-01")`,
                                            type: "avancado"
                                        })}
                                    />
                                }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Popup hoverable content='Kits que foram pré-conferidos no mês atual (Sem vendas).' position="bottom center" trigger={
                                    <Button
                                        icon="times"
                                        fluid
                                        color="grey"
                                        content="Conferidos S/V"
                                        onClick={() => onSearch({
                                            searchString: `CONFERENCES.ANY(CONFERENCE => CONFERENCE.CONFERENCETYPE = 0 AND CONFERENCE.VALORVENDIDO = 0 AND CONFERENCE.DATA >= "${actualYear}-${actualMonth}-01" AND CONFERENCE.DATA < "${actualYear}-${actualMonth + 1}-01")`,
                                            type: "avancado"
                                        })}
                                    />
                                }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Popup hoverable content='Kits que retornaram fora da data correta (Sem vendas).' position="bottom center" trigger={
                                    <Button
                                        icon="thumbs down"
                                        fluid
                                        color="grey"
                                        content="Retornados S/V"
                                        onClick={() => onSearch({
                                            searchString: `CONFERENCES.ANY(CONFERENCE => CONFERENCE.CONFERENCETYPE = 0 AND CONFERENCE.VALORVENDIDO = 0 AND CONFERENCE.DATA >= "${actualYear}-${actualMonth}-01" AND CONFERENCE.DATA < "${actualYear}-${actualMonth + 1}-01") AND PEDIDO.ACERTO != "${actualYear}-${actualMonth}-15"`,
                                            type: "avancado"
                                        })}
                                    />
                                }
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Popup hoverable content='Kits que retornaram fora da data correta (Com vendas).' position="bottom center" trigger={
                                    <Button
                                        icon="thumbs up"
                                        fluid
                                        color="grey"
                                        content="Retornados C/V"
                                        onClick={() => onSearch({
                                            searchString: `CONFERENCES.ANY(CONFERENCE => CONFERENCE.CONFERENCETYPE = 0 AND CONFERENCE.VALORVENDIDO > 0 AND CONFERENCE.DATA >= "${actualYear}-${actualMonth}-01" AND CONFERENCE.DATA < "2022-${actualMonth + 1}-01") AND PEDIDO.ACERTO != "2022-${actualMonth}-15"`,
                                            type: "avancado"
                                        })}
                                    />
                                }
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row textAlign="right">
                            <Grid.Column>
                                <Button
                                    size="tiny"
                                    color="red"
                                    icon="trash"
                                    floated="right"
                                    labelPosition="left"
                                    content="Limpar filtro"
                                    onClick={() => onSearch({ searchString: "", type: "simples" })}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Grid.Column>
        </Grid>
    );

    return (
        <TemplateTable
            title="Kits"
            icon="box"
            insert={role === "Admin" || role === "Operador" ?
                <>
                    <Grid.Row>
                        <CSVLink
                            separator={";"}
                            {...csvReport}
                        >
                            <Popup content='Download Excel' position="bottom center" trigger={
                                <Button
                                    color="green"
                                    icon="download"
                                />
                            } />
                        </CSVLink>
                        <Button
                            content={!predefined ? "Mostrar filtros" : "Ocultar filtros"}
                            labelPosition="left"
                            icon={!predefined ? "eye" : "eye slash"}
                            color={!predefined ? "blue" : "black"}
                            onClick={onClickPredefined}
                        />
                        <Button
                            icon="add"
                            color="pink"
                            content="Novo"
                            labelPosition="left"
                            as={Link}
                            to="/createkit"
                        />
                    </Grid.Row>
                </> : undefined
            }
            tableList={list}
            tableRender={tableRender}
            predefinedFilters={
                <Transition visible={visible} animation="fade down" duration={300}>
                    {predefinedRegion}
                </Transition>
            }
            tableActions={(data: IKitListModel, index: number) => {
                if (role === "Admin" || role === "Operador") {
                    return ([
                        manageButton({
                            id: data.id || "",
                            gerenteSetor: data.gerenteSetor,
                            representante: data.representante,
                            revendedor: data.revendedor,
                            acerto: data.acerto
                        }),
                        <EditarKit key={`kits_edit_${data.id}`} kitId={data.id || ""} onSuccess={load} />,
                        printButton(data.id || "")
                    ]);
                }
                if ((role === "Representante" || role === "GerenteS") && (data.status === eStatusKit.Representante)) {
                    return [<EditarKit key={`kits_edit_${data.id}`} kitId={data.id || ""} onSuccess={load} />];
                }
            }}
            searchPlaceHolder="Número/Representante/Revendedor"
            onSearch={onSearch}
            filterFields={fields}
            tableLoading={loading}
            tableOnChangeRecords={onChangeRecords}
            tablePagination={{
                currentPage: refPageNumber.current,
                totalRecords: refTotalRecords.current,
                totalPages: refTotalPages.current,
                onPageChange: onPageChange
            }}
        />
    );
};

export default Kits;
